<unity-container>
  <h4>List of Services</h4>
  @if (loading) {
    <div>
      <app-loader></app-loader>
    </div>
  }

  <!-- Service Cards-->
  <unity-card-list>
    @for (service of storeService.services$ | async; track service) {
      <li unity-card-list-item>
        <app-service-card [service]="service"></app-service-card>
      </li>
    }
  </unity-card-list>
</unity-container>
